export const WallCardImageLinearGradient =
  "linear-gradient(180deg, rgb(0, 0, 0) -10%, rgba(0,0,0,0), 50%, rgb(0, 0, 0) 120%)";
